import { Translation } from 'primeng/api';

const translation: { primeng: Translation } = {
    primeng: {
        clear: 'reset',
        apply: 'anwenden',
        notContains: 'enthält nicht',
        contains: 'enthält',
        lt: 'kleiner als',
        gt: 'größer als',
        dateIs: 'Datum ist',
        dateIsNot: 'Datum ist nicht',
        dateBefore: 'Datum ist bevor',
        dateAfter: 'Datum ist nach',
        startsWith: 'beginnt mit',
        endsWith: 'endet mit',
        equals: 'ist gleich',
        notEquals: 'ist nicht gleich',
        noFilter: 'kein Filter',
        lte: 'kleiner oder gleich',
        gte: 'größer oder gleich',
        is: 'ist',
        isNot: 'ist nicht',
        before: 'bevor',
        after: 'nach',
        matchAll: 'alle',
        matchAny: '',
        removeRule: 'Regel entfernen',
        accept: 'akzeptieren',
        reject: 'ablehnen',
        choose: 'auswählen',
        upload: 'hochladen',
        cancel: 'abbrechen',
        today: 'Heute',
        weekHeader: 'Wo',
        weak: 'schwach',
        medium: 'mittel',
        strong: 'stark',
        passwordPrompt: 'Passwort eingeben',
        emptyMessage: 'keine Ergebnisse gefunden',
        emptyFilterMessage: 'leere Filternachricht',
        dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
        dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        monthNames: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthNamesShort: ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        addRule: 'Regel hinzufügen',
        dateFormat: 'dd.mm.yy',
        firstDayOfWeek: 1,
    },
};

export default translation;
